import React from 'react'

import HorizontalMenuItem from "../../../../layout/top/header/h-menu/h-menu-item-2"
import {ENTITY_SELECTOR_MENU_HEIGHT, EntitySelectorEntityType} from "../selector"

type Props = {
    menuItems           : any[]
    currentEntityType   : EntitySelectorEntityType

    onSelect            : callback
}

const debug = false
// const debug = "EntitySelectorMenu"

export function EntitySelectorMenu (props:Props) {
    return (
        <div className="entity-selector-menu flex-row-left-bottom flex-no-shrink" style={{height: ENTITY_SELECTOR_MENU_HEIGHT}}>
            <div className="ui5-hmenu menu-underline selector-menu">
                {_.map(props.menuItems, (menu:any)=><HorizontalMenuItem key           = {menu.id}
                                                                  data          = {menu}
                                                                  selectedId    = {props.currentEntityType}
                                                                  onClick       = {props.onSelect}/>)}
            </div>
        </div>
    )
}
